import constants from '@/constants';
import forge from 'node-forge';

function encrypt(plaintext) {
  const publicObj = forge.pki.publicKeyFromPem(constants.PUBLIC_KEY_STRING);
  const encryptTxt = publicObj.encrypt(plaintext, 'RSA-OAEP', {
    md: forge.md.sha256.create(),
    mgf1: {
      md: forge.md.sha1.create()
    }
  });
  return forge.util.encode64(encryptTxt);
}
export function rsaEncrypt(message) {
  const maxLength = constants.ENCRYPT_MAX_LENGTH;
  const bytes = forge.util.createBuffer(message, 'utf8').getBytes();
  const result = [];
  if (bytes.length > maxLength) {
    let str = bytes;
    const list = [];
    while (str.length > maxLength) {
      list.push(str.substring(0, maxLength));
      str = str.substring(maxLength);
    }
    list.push(str);
    list.forEach(item => {
      const resultItem = encrypt(item);
      result.push(resultItem);
    });
    return result.toString();
  }
  return encrypt(message);
}
